import { Component, Input, OnChanges } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: "app-dynamic-message-page",
  templateUrl: "./dynamic-message-article-page.component.html",
  styleUrls: ["./dynamic-message-article-page.component.scss"],
})
export class DynamicMessageArticlePageComponent implements OnChanges {
  @Input() message: any;
  updatedArticles: any[];

  constructor(private router: Router) { }

  ngOnChanges(): void {
    this.updatedArticles = [];
    for (let article of this.message.articles) {      
      let updatedArticle = Object.assign({}, article);
      delete updatedArticle.attributeJson;

      updatedArticle['attributeJson'] = JSON.parse(article.attributeJson);
      this.updatedArticles.push(updatedArticle);
    }
  }

  redirect(messagePageId, articleId, link) {
    if (link)
      window.open(link, "_blank");
    else
      this.router.navigateByUrl(`/articles/messagearticle/${messagePageId}/View/${articleId}`);
  }
}
